module.exports = __webpack_public_path__ + "static/media/administration_head-office_add.1dc29d3e.svg";